export const BuildInfo = {timestamp:1772753038000}
